// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".category-topic-card[data-v-be35770c]{min-height:100%;transition:border-color .15s ease,background-color .15s ease}.category-topic-card[data-v-be35770c]:hover{background:#fafafb;border-color:#cccdd0 !important}.ui-dark .category-topic-card[data-v-be35770c]:hover{background:#2a2b3a;border-color:#3e3f4c !important}.line-clamp-3[data-v-be35770c]{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
